import React, { memo, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useDynamicLineClamp } from '../../../hooks/useDynamicLineClamp';

import CardCoverImageBlock from '../../PlaybooksIndexPage/CardCoverImageBlock/CardCoverImageBlock';
import TruncatingLabelList from '../TruncatingLabelList/TruncatingLabelList';

const PlaybookTemplateCard = ({ template, cardWidth }) => {
    const { id, name, description, icon_color, cover_image, labels } = template;

    const location = useLocation();

    const watchedRef = useRef(null);
    const targetRef = useRef(null);
    const targetContainerRef = useRef(null);

    const lineClamp = useDynamicLineClamp({ watchedRef, targetRef, targetContainerRef });

    return (
        <Link
            to={`/library/playbook/${id}`}
            state={{ from: location }}
            style={{ width: cardWidth, minWidth: cardWidth }}
            className="h-[535px] max-h-[535px] self-stretch rounded-[20px] overflow-hidden flex flex-col"
        >
            <CardCoverImageBlock
                name={name}
                icon_color={icon_color}
                cover_image={cover_image}
                height={279}
            />

            <div className="flex-grow p-5 bg-[#F7F8FA] flex flex-col gap-5 justify-between overflow-hidden">
                <div className="flex-grow flex flex-col overflow-hidden">
                    <p
                        className="font-heading-regular font-[600] text-[24px] leading-[26px] text-black mb-1 line-clamp-4"
                        ref={watchedRef}
                    >
                        {name}
                    </p>
                    <div className="flex-grow" ref={targetContainerRef}>
                        <p
                            className="font-body text-body-regular-s text-neutral-300 overflow-hidden"
                            ref={targetRef}
                            style={{
                                WebkitLineClamp: lineClamp,
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {description}
                        </p>
                    </div>
                </div>
                <TruncatingLabelList labels={labels} />
            </div>
        </Link>
    );
};

export default memo(PlaybookTemplateCard);
